module.exports = __webpack_public_path__ + "static/img/3.4b74c4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/preview/snip3down/3.png
// module id = zXc1
// module chunks = 35